import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { useEventDataOnce } from '../../../api/event';
import { useCurrentUser } from '../../../redux/selectors/authSelectors';
import { useEventId } from '../../../redux/selectors/gameSelectors';
import { EventStatus } from '../../../types';
import CommonBG from '../../uiElements/CommonBG';
import ProfileBar from '../../uiElements/ProfileBar';
import ResultDetail from './ResultDetail';

interface EventResultProps {}
const EventResult: React.FC<EventResultProps> = () => {
  const user = useCurrentUser();
  const eventId = useEventId();
  const [event] = useEventDataOnce(eventId);

  const navigate = useNavigate();
  React.useEffect(() => {
    if (!event) {
      return;
    }
    if (event?.status !== EventStatus.Ended) {
      navigate('/events');
    }
  }, [event, navigate]);

  return (
    <CommonBG withHeader withFooter headerOptions={{ buttonType: 'logout' }}>
      <ProfileBar user={user} disableEmail />
      <ResultDetail uid={user?.uid} eventId={eventId} listHref='/history' />
    </CommonBG>
  );
};
export default EventResult;
